module.exports = __webpack_public_path__ + "img/Slice1-min.dcbf1146.png";